import { inject, Injectable } from '@angular/core';

import { ExtendedCustomer } from '../../../../model/extended-customer.model';
import { RetailCrmAccountDetailsResponse } from '../../model/responses/account-details.model';
import { RetailCrmCustomerFieldsViewModelMapper } from './customer-fields-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmExtendedCustomerViewModelMapper {
  private readonly customerFieldsModelMapper = inject(RetailCrmCustomerFieldsViewModelMapper);

  mapToExtendedCustomer(accountDetails: RetailCrmAccountDetailsResponse): ExtendedCustomer {
    return {
      accountNumber: accountDetails.accountNumber,
      emailPrivate: accountDetails.connection.emailPrivate,
      emailBusiness: accountDetails.connection.emailBusiness,
      firstName: accountDetails.name.firstName,
      lastName: accountDetails.name.lastName,
      middleName: accountDetails.name.middleName,
      suffix: accountDetails.name.suffix,
      salutation: this.customerFieldsModelMapper.mapSalutation(accountDetails.name.salutation),
      title: this.customerFieldsModelMapper.mapTitle(accountDetails.name.title),
      birthdate: accountDetails.name.personBirthdate,
      mobileBusiness: accountDetails.connection.mobileBusiness,
      mobilePrivate: accountDetails.connection.mobilePrivate,
      phoneBusiness: accountDetails.connection.phoneBusiness,
      phonePrivate: accountDetails.connection.phonePrivate,
      privateAddress: this.customerFieldsModelMapper.mapAddress(accountDetails.privateAddress),
      businessAddress: this.customerFieldsModelMapper.mapAddress(accountDetails.businessAddress),
      mainAddress: this.customerFieldsModelMapper.mapMainAddress(accountDetails.mainAddress),
      placeOfBirth: accountDetails.placeOfBirth,
      isInsolvent: accountDetails.isInsolvent,
      vatGroup: this.customerFieldsModelMapper.mapVatGroup(accountDetails.vatGroup),
      nameInitials: accountDetails.name.nameInitials,
      nationalId1: accountDetails.nationalId1,
      nationalId1DocumentType: this.customerFieldsModelMapper.mapNationalIdDocumentType(
        accountDetails.nationalId1DocumentType,
      ),
      nationality: accountDetails.nationality,
      selfEmployed: accountDetails.individualDetails?.selfEmployed,
      customerMainType: this.customerFieldsModelMapper.mapCustomerMainType(accountDetails.customerMainType),
      description: accountDetails.description,
      taxNumber: accountDetails.taxNumber,
      taxNumberCountry: accountDetails.taxNumberCountry,
      correspondenceLanguage: accountDetails.correspondenceLanguage,
    };
  }
}
